/**
 * Klasse PORTAL_GLOCKE_EREIGNIS.
 * Sprung nur zu Typen, die die Glocke schon führt. Kein neuer Typ.
 * Hell: Fläche #f3efe8, Text #1c1915, Flieder #5b4678. Dunkel bleibt dunkel.
 */
import type { PortalView } from './portalNavigation';

export const GLOCKE_SPRUNG_EVENT = 'arkorbit:sitz-glocke-sprung';

export const GLOCKE_LIGHT_SURFACE = '#f3efe8';
export const GLOCKE_LIGHT_TEXT = '#1c1915';
export const GLOCKE_LIGHT_ACCENT = '#5b4678';

export type GlockeSprungSource = 'akte' | 'termin' | 'dokument' | 'element' | 'analyse';

export type GlockeSprung = {
  source: GlockeSprungSource;
  refId: string;
  /** Analyse öffnet Dokumente. Der Untertab liest die Kennung. */
  view: PortalView | null;
};

export type GlockePanelColors = {
  surface: typeof GLOCKE_LIGHT_SURFACE;
  text: typeof GLOCKE_LIGHT_TEXT;
  accent: typeof GLOCKE_LIGHT_ACCENT;
};

const VIEW_BY_SOURCE: Record<Exclude<GlockeSprungSource, 'analyse'>, PortalView> = {
  akte: 'akten',
  termin: 'kalender',
  dokument: 'dokumente',
  element: 'matrix',
};

let pending: GlockeSprung | null = null;

/** Hell liefert die Stein-Fläche. Dunkel bleibt beim bestehenden Panel, ohne Aufhellen. */
export function glockePanelColors(appearance: 'light' | 'dark'): GlockePanelColors | null {
  if (appearance === 'light') {
    return {
      surface: GLOCKE_LIGHT_SURFACE,
      text: GLOCKE_LIGHT_TEXT,
      accent: GLOCKE_LIGHT_ACCENT,
    };
  }
  return null;
}

/**
 * Bekannte Quellen: Akte, Termin, Dokument, Element, Analyse.
 * Alles andere bleibt ohne Sprung.
 */
export function glockeSprungFor(source: string, refId: string): GlockeSprung | null {
  const id = refId.trim();
  if (!id || id.length > 255) return null;
  if (source === 'analyse') return { source: 'analyse', refId: id, view: 'dokumente' };
  if (source === 'akte' || source === 'termin' || source === 'dokument' || source === 'element') {
    return { source, refId: id, view: VIEW_BY_SOURCE[source] };
  }
  return null;
}

export function publishGlockeSprung(sprung: GlockeSprung): void {
  pending = sprung;
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<GlockeSprung>(GLOCKE_SPRUNG_EVENT, { detail: sprung }));
}

export function peekGlockeSprung(): GlockeSprung | null {
  return pending;
}

export function takeGlockeSprung(source: GlockeSprungSource): GlockeSprung | null {
  if (!pending || pending.source !== source) return null;
  const hit = pending;
  pending = null;
  return hit;
}
